// Generated by purs version 0.15.15
import * as Effect_Unsafe from "../Effect.Unsafe/index.js";
import * as Specular_Internal_Incremental_Ref from "../Specular.Internal.Incremental.Ref/index.js";
var stabilizationIsNotInProgress = /* #__PURE__ */ (function () {
    return -1 | 0;
})();
var globalTotalRefcount = /* #__PURE__ */ Effect_Unsafe.unsafePerformEffect(function () {
    return Specular_Internal_Incremental_Ref["new"](0);
});
var globalLastStabilizationNum = /* #__PURE__ */ Effect_Unsafe.unsafePerformEffect(function () {
    return Specular_Internal_Incremental_Ref["new"](0);
});
var globalCurrentStabilizationNum = /* #__PURE__ */ Effect_Unsafe.unsafePerformEffect(function () {
    return Specular_Internal_Incremental_Ref["new"](stabilizationIsNotInProgress);
});
export {
    stabilizationIsNotInProgress,
    globalLastStabilizationNum,
    globalCurrentStabilizationNum,
    globalTotalRefcount
};
